"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2612],{

/***/ 2612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RenderBlock; }
/* harmony export */ });
/* unused harmony export SliderComponent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5896);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9612);
/* harmony import */ var _comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9460);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6254);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1816);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2213);








function RenderBlock(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var basic = props.basic, advanced = props.advanced, isYearly = props.isYearly, handlePurchaseClick = props.handlePurchaseClick, plans = props.plans;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)().userInfo;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_4__/* .useAdjustLogger */ .eW)();
    var ref6 = (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentPackId */ .V2)(userInfo.entitlements), currentPackId = ref6.packId;
    var yearlyPricePro = ((ref = basic.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref === void 0 ? void 0 : ref.price) || 0;
    var yearlyPriceDividedPro = yearlyPricePro / 12;
    var yearlyPriceFormattedPro = Math.floor(yearlyPriceDividedPro);
    var yearlyPriceAdvanced = ((ref1 = advanced.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref1 === void 0 ? void 0 : ref1.price) || 0;
    var yearlyPriceDividedAdvanced = yearlyPriceAdvanced / 12;
    var yearlyPriceFormattedAdvanced = Math.floor(yearlyPriceDividedAdvanced);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-10 flex w-full flex-col items-center justify-center gap-6 px-4 tablet:px-5 desktop:flex-row desktop:gap-[27px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex w-full flex-col overflow-hidden rounded-[8px] border-2 border-color-separator", "tablet:flex-row desktop:h-[468px] desktop:w-[310px] desktop:flex-col"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-1 flex-col justify-between bg-color-surface-cell p-[18px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[24px] font-600 text-blue-900",
                                        children: "Pro + AI"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-300 text-[14px] text-blue-600",
                                        children: "For pro video creation"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative mt-3 h-[50px] w-full overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-16", "transition-all duration-500"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                        children: [
                                                            "$",
                                                            String((ref2 = basic.variants[0].periods.find(function(a) {
                                                                return a.period === "monthly";
                                                            })) === null || ref2 === void 0 ? void 0 : ref2.price).slice(0, -2),
                                                            ".",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: String((ref3 = basic.variants[0].periods.find(function(a) {
                                                                    return a.period === "monthly";
                                                                })) === null || ref3 === void 0 ? void 0 : ref3.price).slice(-2)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                        children: [
                                                            "/",
                                                            t("txt_month")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-16", "transition-all duration-500"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                        children: [
                                                            "$",
                                                            String(yearlyPriceFormattedPro).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedPro).slice(0, -2) : 0,
                                                            ".",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: String(yearlyPriceFormattedPro).slice(-2)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                        children: [
                                                            "/",
                                                            t("txt_month"),
                                                            "*"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_1__/* .GradientGrayscaleButton */ .sH, {
                                    grayscale: true,
                                    disabled: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__/* .getBasicButtonText */ .hv)(currentPackId) === "txt_current_plan",
                                    onClick: function() {
                                        return handlePurchaseClick(basic.variants[0].pack_id);
                                    },
                                    className: "flex h-[52px] w-full items-center justify-center !font-500 disabled:!text-color-inactive-text",
                                    text: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__/* .getBasicButtonText */ .hv)(currentPackId)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px] desktop:h-[1px] desktop:w-full"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-2 bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 desktop:h-[160px] desktop:w-full desktop:gap-1",
                        children: plans.basic.points.map(function(point) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-[10px] ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_2__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/pricing/check"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[14px] font-400 text-blue-800",
                                        children: point
                                    })
                                ]
                            }, point);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative flex w-full flex-col rounded-[10px]", "tablet:flex-row desktop:h-[464px] desktop:w-[310px] desktop:flex-col"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            background: "linear-gradient(120deg, rgba(134, 54, 248, 1), rgba(240, 32, 179, 1), rgba(248, 71, 94, 1), rgba(255, 148, 33, 1) )"
                        },
                        className: "absolute left-[-2px] top-[-2px] h-[calc(100%+4px)] w-[calc(100%+4px)] rounded-[10px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "z-10 flex w-full flex-1 flex-col justify-between rounded-t-[8px] bg-color-surface-cell p-[18px] tablet:rounded-l-[8px] tablet:rounded-r-[0px] desktop:rounded-b-[0px] desktop:rounded-t-[8px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[24px] font-600 text-blue-900",
                                        children: "Advanced + AI"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-300 text-[14px] text-blue-600",
                                        children: t("txt_pro_subtitle")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative mt-3 h-[50px] w-full overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-16", "transition-all duration-500"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                        children: [
                                                            "$",
                                                            String((ref4 = advanced.variants[0].periods.find(function(a) {
                                                                return a.period === "monthly";
                                                            })) === null || ref4 === void 0 ? void 0 : ref4.price).slice(0, -2),
                                                            ".",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: String((ref5 = advanced.variants[0].periods.find(function(a) {
                                                                    return a.period === "monthly";
                                                                })) === null || ref5 === void 0 ? void 0 : ref5.price).slice(-2)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                        children: [
                                                            "/",
                                                            t("txt_month")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-16", "transition-all duration-500"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("font-700 text-blue-900", "text-[38px]"),
                                                        children: [
                                                            "$",
                                                            String(yearlyPriceFormattedAdvanced).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedAdvanced).slice(0, -2) : 0,
                                                            ".",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                                children: String(yearlyPriceFormattedAdvanced).slice(-2)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                        children: [
                                                            "/",
                                                            t("txt_month"),
                                                            "*"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8 flex w-full tablet:mt-12 desktop:mt-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                                    gradient: true,
                                    disabled: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__/* .getAdvancedButtonText */ .JH)(currentPackId) === "txt_current_plan",
                                    onClick: function() {
                                        return handlePurchaseClick(advanced.variants[0].pack_id);
                                    },
                                    className: "flex h-[52px] w-full items-center justify-center !font-500",
                                    text: (0,_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_3__/* .getAdvancedButtonText */ .JH)(currentPackId)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-10 h-[1px] w-full bg-blue-100 tablet:h-[259px] tablet:w-[1px] desktop:h-[1px] desktop:w-full"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-10 flex flex-col gap-2 rounded-b-[8px] bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 tablet:rounded-l-none tablet:rounded-r-[8px] desktop:h-[160px] desktop:w-full desktop:gap-1 desktop:rounded-b-[8px] desktop:rounded-t-[0px]",
                        children: plans.advanced.points.map(function(point) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-[10px] ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_2__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/pricing/check"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[14px] font-400 text-blue-800",
                                        children: point
                                    })
                                ]
                            }, point);
                        })
                    })
                ]
            })
        ]
    });
}
function SliderComponent(props) {
    var variants = props.variants, isYearly = props.isYearly, setPackId = props.setPackId, value = props.value, setValue = props.setValue;
    var values = variants.map(function(a) {
        return isYearly ? a.yearly_tokens : a.monthly_tokens;
    });
    var min = 0;
    var max = values.length - 1;
    var selectedPart = value / (values.length - 1) * 100;
    var selectedPosition = "".concat(selectedPart, "%");
    if (selectedPart === 0) {
        selectedPosition = "22px";
    } else if (selectedPart !== 0 && selectedPart < 100) {
        selectedPosition = "calc(".concat(selectedPart, "% + 10px)");
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "my-10 flex flex-col tablet:my-10 desktop:my-0",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "range",
                        min: min,
                        max: max,
                        step: 1,
                        value: value,
                        className: "relative z-[100] w-full cursor-grab opacity-0 active:cursor-grabbing",
                        onChange: function(e) {
                            var newSelected = parseInt(e.currentTarget.value);
                            var variant = variants[newSelected];
                            var packId = variant.pack_id;
                            setValue(newSelected);
                            setPackId(packId);
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "absolute left-0 top-1/2 z-10 h-5 w-full -translate-y-1/2 rounded-[18px] border border-color-separator bg-color-background"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "absolute left-0 top-1/2 z-30 h-5 w-full -translate-y-1/2 overflow-hidden rounded-[18px] p-[2px]",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "h-full rounded-[18px] bg-green-500 transition-all",
                                    style: {
                                        width: selectedPosition
                                    }
                                })
                            }),
                            values.map(function(_, index) {
                                var part = index / (values.length - 1);
                                var position = "".concat(part * 100, "%");
                                if (part === 0) {
                                    position = "13px";
                                } else if (part === 1) {
                                    position = "calc(".concat(part * 100, "% - 13px)");
                                }
                                return /*#__PURE__*/ _jsx("div", {
                                    className: clsx("absolute top-1/2 z-50 h-[4px] w-[4px] -translate-y-1/2 rounded-full transition-all", value === index && " scale-[2]", index > value ? "bg-blue-300" : "bg-color-white"),
                                    style: {
                                        left: position
                                    }
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "relative mt-1 h-4",
                children: values.map(function(token, index) {
                    var part = index / (values.length - 1);
                    var position = part;
                    var firstPoint = index === 0;
                    var lastPoint = index === values.length - 1;
                    var middlePoint = !firstPoint && !lastPoint;
                    return /*#__PURE__*/ _jsx("button", {
                        onClick: function(e) {
                            e.preventDefault();
                            var variant = variants[index];
                            var packId = variant.pack_id;
                            setValue(index);
                            setPackId(packId);
                        },
                        className: clsx("absolute bottom-0", "text-[13px] transition-colors", middlePoint && "-translate-x-1/2", lastPoint && "-translate-x-full", value === index ? "font-600 text-blue-800" : "font-500 text-blue-400"),
                        style: {
                            left: "".concat(position * 100, "%")
                        },
                        children: token
                    }, token);
                })
            })
        ]
    });
}


/***/ })

}]);